// This file is AUTOGENERATED, do not edit it manually!!!

import { koPeopleTemplates as koPeopleTemplatesde } from './koPeopleTemplatesResx.de';
import { koPeopleTemplates as koPeopleTemplatesen } from './koPeopleTemplatesResx.en';
import { koPeopleTemplates as koPeopleTemplatesen_risk } from './koPeopleTemplatesResx.en_risk';
import { koPeopleTemplates as koPeopleTemplateses } from './koPeopleTemplatesResx.es';
import { koPeopleTemplates as koPeopleTemplatesfr } from './koPeopleTemplatesResx.fr';
import { koPeopleTemplates as koPeopleTemplatesit } from './koPeopleTemplatesResx.it';
import { koPeopleTemplates as koPeopleTemplatesnl } from './koPeopleTemplatesResx.nl';
import { koPeopleTemplates as koPeopleTemplatespl } from './koPeopleTemplatesResx.pl';
import { koPeopleTemplates as koPeopleTemplatespt } from './koPeopleTemplatesResx.pt';
import { koPeopleTemplates as koPeopleTemplatesru } from './koPeopleTemplatesResx.ru';
import { koPeopleTemplates as koPeopleTemplatessk } from './koPeopleTemplatesResx.sk';
import { koPeopleTemplates as koPeopleTemplatessv } from './koPeopleTemplatesResx.sv';
import { koPeopleTemplates as koPeopleTemplatestr } from './koPeopleTemplatesResx.tr';

const langMap: { [k: string]: Partial<typeof koPeopleTemplatesen> } = {
    de: koPeopleTemplatesde,
    en: koPeopleTemplatesen,
    en_risk: koPeopleTemplatesen_risk,
    es: koPeopleTemplateses,
    fr: koPeopleTemplatesfr,
    it: koPeopleTemplatesit,
    nl: koPeopleTemplatesnl,
    pl: koPeopleTemplatespl,
    pt: koPeopleTemplatespt,
    ru: koPeopleTemplatesru,
    sk: koPeopleTemplatessk,
    sv: koPeopleTemplatessv,
    tr: koPeopleTemplatestr,
};

/* tslint:disable: max-line-length */
export const koPeopleTemplatesResx = {
    /**
    * en: Sorry, nothing was found
    */
    get nomatch_text() {
        return langMap[ep.resxCulture].nomatch_text || langMap.en.nomatch_text;
    },
    /**
    * en: Roles
    */
    get roles() {
        return langMap[ep.resxCulture].roles || langMap.en.roles;
    },
    /**
    * en: Teams
    */
    get teams() {
        return langMap[ep.resxCulture].teams || langMap.en.teams;
    },
    /**
    * en: Users
    */
    get users() {
        return langMap[ep.resxCulture].users || langMap.en.users;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.koPeopleTemplates = koPeopleTemplatesResx;
